import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { useLocation } from "react-router-dom";
import CommonSection from "../Shared/CommonSection";
import CabCard from "../Shared/CabCard";
import CabBookingModal from "../Component/Booking/CabBookingModal";
import cabs from "../assest/data/cabs";
import "../styles/cab-search.css";

const CabSearchResults = () => {
  const location = useLocation();
  const searchData = location.state || JSON.parse(localStorage.getItem("cabSearchData") || "{}");
  
  const [selectedCab, setSelectedCab] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortBy, setSortBy] = useState("recommended");
  const [filterType, setFilterType] = useState("all");

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleBookNow = (cab) => {
    setSelectedCab(cab);
    setIsModalOpen(true);
  };

  // Filter cabs by type
  const filteredCabs = filterType === "all" 
    ? cabs 
    : cabs.filter(cab => cab.type.toLowerCase().includes(filterType.toLowerCase()));

  // Sort cabs
  const sortedCabs = [...filteredCabs].sort((a, b) => {
    switch (sortBy) {
      case "price-low":
        return a.basePrice - b.basePrice;
      case "price-high":
        return b.basePrice - a.basePrice;
      case "rating":
        return b.rating - a.rating;
      case "seats":
        return b.seats - a.seats;
      default:
        return b.rating - a.rating; // recommended = by rating
    }
  });

  // Get unique vehicle types for filter
  const vehicleTypes = ["all", ...new Set(cabs.map(cab => cab.type))];

  return (
    <>
      <CommonSection title="Available Cabs" />
      
      <section className="cab__results__section">
        <Container>
          {/* Search Summary */}
          <div className="search__summary">
            <div className="search__summary__content">
              <div className="route__info">
                <span className="route__point">
                  <i className="ri-map-pin-line"></i>
                  {searchData.pickup || "Not specified"}
                </span>
                <span className="route__arrow">
                  <i className="ri-arrow-right-line"></i>
                </span>
                <span className="route__point">
                  <i className="ri-map-pin-2-line"></i>
                  {searchData.drop || "Not specified"}
                </span>
              </div>
              <div className="trip__datetime">
                <span>
                  <i className="ri-calendar-line"></i>
                  {searchData.date || "Date not set"}
                </span>
                <span>
                  <i className="ri-time-line"></i>
                  {searchData.time || "Time not set"}
                </span>
              </div>
            </div>
          </div>

          {/* Filters and Sort */}
          <Row className="filter__sort__row">
            <Col lg="8" md="7">
              <div className="filter__section">
                <span className="filter__label">Filter by:</span>
                <div className="filter__buttons">
                  {vehicleTypes.map((type, index) => (
                    <button
                      key={index}
                      className={`filter__btn ${filterType === type ? "active" : ""}`}
                      onClick={() => setFilterType(type)}
                    >
                      {type === "all" ? "All Vehicles" : type}
                    </button>
                  ))}
                </div>
              </div>
            </Col>
            <Col lg="4" md="5">
              <div className="sort__section">
                <label>Sort by:</label>
                <select 
                  value={sortBy} 
                  onChange={(e) => setSortBy(e.target.value)}
                  className="sort__select"
                >
                  <option value="recommended">Recommended</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="rating">Highest Rated</option>
                  <option value="seats">Most Seats</option>
                </select>
              </div>
            </Col>
          </Row>

          {/* Results Count */}
          <div className="results__count">
            <span>{sortedCabs.length} vehicles available</span>
          </div>

          {/* Cab Cards */}
          <Row>
            {sortedCabs.length > 0 ? (
              sortedCabs.map((cab) => (
                <Col lg="4" md="6" sm="12" key={cab.id}>
                  <CabCard cab={cab} onBookNow={handleBookNow} />
                </Col>
              ))
            ) : (
              <Col lg="12">
                <div className="no__results">
                  <i className="ri-car-line"></i>
                  <h4>No vehicles available</h4>
                  <p>Try adjusting your filters to see more options.</p>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>

      {/* Booking Modal */}
      <CabBookingModal 
        isOpen={isModalOpen}
        toggle={toggleModal}
        cab={selectedCab}
        searchData={searchData}
      />
    </>
  );
};

export default CabSearchResults;
